import {
  MENU_TOGGLE_MENU,
  MENU_TOGGLE_MENU_OPEN,
  MENU_CHANGE_MENU,
  MENU_UPDATE_ITEMS_MENU,
  MENU_UPDATE_ITEM_MENU,
  MENU_UPDATE_ITEM_SELECTED,
  MENU_RESET_REDUX,
  MENU_UPDATE_ANALYTICS,
  MENU_REORDER_ANALYTICS
} from '../actions/menuActions'

const initState = {
  isMenuOpen: true,
  items: [],
  selected: {
    item: '',
    subItem: ''
  },
  changeMenu: false,
  menuAnalyticsList: [],
  textCurriculum: '^Victorian Curriculum F-10 references © VCAA 2017'
}

const menuReducer = (state = initState, action) => {
  const newState = { ...state }

  switch (action.type) {
    case MENU_RESET_REDUX:
      return JSON.parse(JSON.stringify({ ...initState }))
    case MENU_TOGGLE_MENU:
      newState.isMenuOpen = !newState.isMenuOpen
      break
    case MENU_TOGGLE_MENU_OPEN:
      newState.isMenuOpen = action.open
      break
    case MENU_CHANGE_MENU:
      newState.changeMenu = !newState.changeMenu
      break
    case MENU_UPDATE_ITEM_SELECTED:
      if (newState.selected) {
        newState.selected.item = action.payload.selected.item
        newState.selected.subItem = action.payload.selected.subItem
        return newState
      }
      break
    case MENU_UPDATE_ITEMS_MENU:
      newState.items = action.payload.items
      break

    case MENU_UPDATE_ITEM_MENU: {
      const { item, subItem, data } = action.payload?.item || { item: '', subItem: '', data: {} }

      const modifiedItems = newState?.items?.map((module) => {
        if (module?.id === item) {
          return {
            ...module,
            items: module.items.map((subModule) => {
              if (subModule.id === subItem) {
                return {
                  ...subModule,
                  ...data
                }
              }
              return subModule
            })
          }
        }
        return module
      })

      return { ...newState, items: modifiedItems }
    }

    case MENU_UPDATE_ANALYTICS: {
      newState.menuAnalyticsList = action.payload.menuAnalyticsList
      let stateToUpdate = {}
      newState.items.find((el, index) => {
        if (el.id === 'analytics') {
          const data = { element: el, index: index }
          stateToUpdate = data
        }
        return null
      })

      let temStateToUpdate = { ...stateToUpdate }
      if (temStateToUpdate.element?.items) {
        temStateToUpdate.element.items.forEach((element, indx) => {
          const find = action.payload.menuAnalyticsList.find((el) => {
            // The BE builds the permission key as `${position}_${code}_${engine}`
            // (engine defaults to 'tableau'). Match that, and keep matching the
            // legacy `${position}_${code}` key for backward compatibility.
            const base = `${el.position}_${el.code}`
            const withEngine = `${base}_${el.engine || 'tableau'}`
            return element.id === base || element.id === withEngine
          })
          if (find) {
            stateToUpdate.element.items[indx].label = find.name
          }
        })
      }
      let newItems = [...newState.items]
      newItems[stateToUpdate.index] = stateToUpdate.element
      return { ...newState, items: [...newItems] }
    }
    case MENU_REORDER_ANALYTICS: {
      // keys are "<position>_<code>_<engine>"; Board Builder stays first, with the divider after it
      const rank = new Map(action.payload.codes.map((code, i) => [code, i]))
      const codeOf = (item) => String(item.id).split('_')[1]
      const items = newState.items.map((group) => {
        if (group.id !== 'analytics' || !group.items) return group
        const builder = group.items.filter((x) => x.id === 'board-builder')
        const rest = group.items
          .filter((x) => x.id !== 'board-builder')
          .map((x) => ({ ...x, divider: false }))
          .sort((a, b) => (rank.get(codeOf(a)) ?? 1e9) - (rank.get(codeOf(b)) ?? 1e9))
        if (builder.length && rest.length) rest[0] = { ...rest[0], divider: true }
        return { ...group, items: [...builder, ...rest] }
      })
      return { ...newState, items }
    }
    default:
      break
  }

  return newState
}

export default menuReducer
